import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
/**
 * Spinner component
 */
@Component({
	selector: 'app-ehe-spinner-hide',
	templateUrl: './spinner.component.html',
	styleUrls: ['./spinner.component.scss'],
})
export class SpinnerHideComponent {
	/**
	 * Spinner component constructor
	 * @param spinner - NgxSpinner Service
	 */
	constructor(private spinner: NgxSpinnerService) {}

	/** trigger the loader */
	startLoader() {
		this.spinner.show();
	}
	/** stop the loader */
	stopLoader() {
		this.spinner.hide();
	}
}
